module.exports = "/_next/static/images/search_bg_5-b31c74ccd95099c5eebcb111ec7f282f.jpg";